import React, { useContext } from 'react';

import { type DialogConfig } from '../ui/dialogs/shared/types';

export const DialogContext = React.createContext<DialogConfig | null>(null);

export function useDialogContext() {
	return useContext(DialogContext);
}
